import React from 'react';

const Home = () => (
  <div className="home">
    <h2>Welcome to our page!</h2>
    <p>
      Hello there, math magician! This is the Math Magicians web app. The web app is simple. It
      has three pages, this is the
      <strong> Home </strong>
      page where you can see some information about the web app and how it works.
    </p>
    <p>
      The next page you will find is the
      <strong> Calculator </strong>
      page, where you will be able to do some simple calculations using our
      <strong> Web Calculator</strong>
      . Make sure to give it a try, you might like math more than
      what you think you do.
    </p>
    <p>
      The last page you will find in this site is the
      <strong> Quote </strong>
      page. Where you will find a quote from a famous math magician.
    </p>
    <p>
      I hope you enjoy this website. Lets explore the other pages, click on the links above!
    </p>
  </div>
);

export default Home;
